import apiClient from './apiClient';

export interface Role {
  Roles_ID: string;
  name: string;
  description: string;
  user_count: number;
}

export interface RoleCreate {
  name: string;
  description?: string;
}

export interface RoleUpdate {
  name: string;
  description?: string;
}

export interface RoleUser {
  User_ID: string;
  firstname: string;
  lastname: string;
  mail: string;
  title?: string;
  jobtitle?: string;
  created_at?: string;
  firm?: {
    Firm_ID: string;
    name: string;
    abbrev: string;
  };
}

export const roleApi = {
  // Get all roles
  getAllRoles: async (): Promise<Role[]> => {
    try {
      const response = await apiClient.get<Role[]>('/api/v2/web/roles');
      return response.data;
    } catch (error) {
      console.error('Error fetching roles:', error);
      throw error;
    }
  },

  // Get role by ID
  getRoleById: async (roleId: string): Promise<Role> => {
    try {
      const response = await apiClient.get<Role>(`/api/v2/web/roles/${roleId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching role:', error);
      throw error;
    }
  },

  // Create new role
  createRole: async (roleData: RoleCreate): Promise<Role> => {
    try {
      const response = await apiClient.post<Role>('/api/v2/web/roles', roleData);
      return response.data;
    } catch (error) {
      console.error('Error creating role:', error);
      throw error;
    }
  },

  // Update role
  updateRole: async (roleId: string, roleData: RoleUpdate): Promise<Role> => {
    try {
      const response = await apiClient.put<Role>(`/api/v2/web/roles/${roleId}`, roleData);
      return response.data;
    } catch (error) {
      console.error('Error updating role:', error);
      throw error;
    }
  },

  // Delete role
  deleteRole: async (roleId: string): Promise<{ message: string }> => {
    try {
      const response = await apiClient.delete<{ message: string }>(`/api/v2/web/roles/${roleId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting role:', error);
      throw error;
    }
  },

  // Get users for a specific role
  getRoleUsers: async (roleId: string): Promise<RoleUser[]> => {
    try {
      const response = await apiClient.get<RoleUser[]>(`/api/v2/web/roles/${roleId}/users`);
      return response.data;
    } catch (error) {
      console.error('Error fetching role users:', error);
      throw error;
    }
  },
};
